module.exports = __webpack_public_path__ + "img/hero.80a1a10a.jpg";